import { logger, ConsoleProvider } from '@paysera/paysera-logger';
import Raven from 'raven-js';
import RavenProvider from './RavenProvider';
import isTelemetryDisabled from '../telemetry/isTelemetryDisabled';

// An unconfigured Raven never transmits - every report would carry the current URL.
if (!isTelemetryDisabled()) {
    Raven.config(
        process.env.PUBLIC_SENTRY_DSN,
        {
            whitelistUrls: ["paysera.", "webpack:"],
            allowDuplicates: false,
        }
    ).install().noConflict();
}

window.Raven = Raven;

// default logger provider
if (process.env.NODE_ENV === 'production') {
    logger.addProvider(new RavenProvider(Raven));
} else {
    logger.addProvider(new ConsoleProvider());
}

export default Raven;
